// extracted by mini-css-extract-plugin
module.exports = {"table":"H4nzDwUNcvEhfDWkmBmXY","center":"tJeJ7upZX0pEg_74wufy6","fakeButton":"_2VH8vJefL8JJWoiK2MkctO","button":"_3E7ueJC6eYluFATR6taQ0v"};